import { combineReducers } from '@reduxjs/toolkit';
import { i18nState } from 'redux-i18n';
import { bookingFormState, modalDialogState } from 'bookingform';
import { booking } from './Booking';

//'./Booking'; // Importa el reducer por defecto

import { cart } from './Cart';
import { mybooking } from './MyBooking';
import { session } from './Session';
import { loyalty } from './Loyalty';
import { extras } from './Extras';

const rootReducer = combineReducers({
  booking, // Usa el nombre de la variable del slice aquí
  i18nState,
  bookingFormState,
  modalDialogState,
  cart,
  mybooking,
  session,
  loyalty,
  extras,
});

export default rootReducer;
